const initialState = {
    empresaSeleccionada: localStorage.getItem('empresa') || null,
};

const empresa = (state = initialState, action) => {
    //console.log("state actual: ", state);
    switch (action.type) {
        case 'SET_EMPRESA':
            localStorage.setItem('empresa', action.payload);
            return { ...state, empresaSeleccionada: action.payload };
        default:
            return state;
    }
};

export default empresa;
